import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ContactPanel } from '../components/ContactPanel';
import { Heart, Shield, MessageCircle, Award } from 'lucide-react';
export function AboutUs() {
  const values = [{
    icon: Heart,
    title: 'Reliable',
    description: 'We arrive on time and complete every job to the highest standard, ensuring your appliances work properly.'
  }, {
    icon: Shield,
    title: 'Transparent',
    description: 'Clear pricing with no hidden fees. You will know exactly what you are paying for before we start any work.'
  }, {
    icon: MessageCircle,
    title: 'Polite',
    description: 'We listen carefully to your concerns, treat your home with respect, and communicate clearly throughout the process.'
  }, {
    icon: Award,
    title: 'Professional',
    description: 'Our qualified engineers follow manufacturer standards and safety guidelines on every visit.'
  }];
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-374">
      <Header data-id="element-375" />
      <main className="flex-grow" data-id="element-376">
        <section className="py-20 bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white" data-id="element-377">
          <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-378">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-379">
              About Caringhand
            </h1>
            <p className="text-xl text-gray-100" data-id="element-380">
              Professional appliance repair services you can trust
            </p>
          </div>
        </section>
        <section className="py-16 bg-white" data-id="element-381">
          <div className="max-w-4xl mx-auto px-4" data-id="element-382">
            <div className="prose prose-lg max-w-none" data-id="element-383">
              <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-384">
                Caringhand provides domestic appliance diagnostics, repair, and
                maintenance across the UK for washing machines, dishwashers,
                tumble dryers, cookers, fridges, and TVs.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-385">
                We arrive on time, listen carefully, and complete all work
                safely to manufacturer standards.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-386">
                Our goal: reliable repairs, done right.
              </p>
            </div>
            <div className="mt-12 grid md:grid-cols-2 gap-8" data-id="element-387">
              <div className="bg-gray-50 p-8 rounded-xl" data-id="element-388">
                <h3 className="text-2xl font-semibold mb-4 text-gray-900" data-id="element-389">
                  Our Mission
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-390">
                  To provide fast, professional appliance repair services that
                  restore your household to normal as quickly as possible, with
                  transparent pricing and exceptional customer care.
                </p>
              </div>
              <div className="bg-gray-50 p-8 rounded-xl" data-id="element-391">
                <h3 className="text-2xl font-semibold mb-4 text-gray-900" data-id="element-392">
                  Our Experience
                </h3>
                <p className="text-gray-700 leading-relaxed" data-id="element-393">
                  Our team of qualified engineers brings years of experience
                  working with all major appliance brands, ensuring expert
                  diagnostics and repairs for any issue you may encounter.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="py-16 bg-gray-50" data-id="element-394">
          <div className="max-w-7xl mx-auto px-4" data-id="element-395">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-396">
              Our Team & Values
            </h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-397">
              {values.map((value, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow text-center" data-id="element-398">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-[#0D7377] bg-opacity-10 rounded-full mb-6" data-id="element-399">
                    <value.icon className="text-[#0D7377]" size={32} data-id="element-400" />
                  </div>
                  <h3 className="font-semibold text-xl mb-3 text-gray-900" data-id="element-401">
                    {value.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-402">
                    {value.description}
                  </p>
                </div>)}
            </div>
          </div>
        </section>
        <ContactPanel data-id="element-403" />
      </main>
      <Footer data-id="element-404" />
    </div>;
}